module.exports = __webpack_public_path__ + "static/media/ICON_CART_ACTIVE.7cfb5d5e.svg";